(() => {
  'use-strict';

  window.addEventListener('load', () => {
    const form = document.querySelectorAll('form[id^="views-exposed-form"]:not([id*="search"])');
    if (form.length && (window.location.search.length || window.location.href.endsWith('?'))) {
      window.location.hash = form[0].id;
    }
  });
})();
